import React from 'react';
import { FadeIn } from './FadeIn';
import { Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-16 md:py-24 bg-teal-900 text-white relative overflow-hidden" data-id="element-120">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#FFF8F0 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-121"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-122">
        <FadeIn data-id="element-123">
          <div className="flex justify-center mb-6" data-id="element-124">
            <div className="w-16 h-16 rounded-full bg-teal-800 flex items-center justify-center border-2 border-teal-500" data-id="element-125">
              <Activity className="w-8 h-8 text-teal-200" data-id="element-126" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-10 text-cream-50" data-id="element-127">
            Presentamos el Método de Descompresión por Gravedad
          </h2>
        </FadeIn>

        <div className="bg-teal-800/50 backdrop-blur-sm p-8 md:p-12 rounded-2xl border border-teal-700" data-id="element-128">
          <FadeIn delay={0.1} data-id="element-129">
            <p className="text-xl md:text-2xl text-teal-50 mb-6 leading-relaxed font-serif italic text-center" data-id="element-130">
              En lugar de estirar, utilizamos posturas estratégicas y tu propio
              peso corporal para crear un vacío natural entre tus vértebras.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-131">
            <p className="text-lg text-teal-100 mb-6 leading-relaxed text-center" data-id="element-132">
              Este vacío permite que el disco se retraiga y deje de pellizcar el
              nervio ciático de forma mecánica y segura.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-133">
            <div className="mt-8 text-center" data-id="element-134">
              <span className="inline-block py-2 px-6 rounded-full bg-teal-700 text-teal-100 font-medium tracking-wide border border-teal-600" data-id="element-135">
                Es ciencia física aplicada en tu propia alfombra o cama.
              </span>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}